import { useLayoutEffect } from "react";

import { Paths, SandboxUrlLoginRedirect } from "configs";
import { useLocation, Navigate } from "react-router-dom";
import { useAppSelector } from "stores";

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { status } = useAppSelector((state) => state.auth);
  const isLoggedIn = status === "AUTH";

  useLayoutEffect(() => {
    if (isLoggedIn) return;
    window.location.replace(SandboxUrlLoginRedirect as string);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (!isLoggedIn) return null;
  return children;
};

export const ProtectedAuth = ({ children }: { children: JSX.Element }) => {
  const { status } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const previousLocation: Location | undefined = location.state?.from;

  if (status === "AUTH") {
    return (
      <Navigate
        to={
          previousLocation
            ? previousLocation.pathname + previousLocation.search
            : Paths.General.App
        }
        replace
      />
    );
  }

  return children;
};
